import { render } from "./UserManagement.vue?vue&type=template&id=55739d39&scoped=true"
import script from "./UserManagement.vue?vue&type=script&lang=js"
export * from "./UserManagement.vue?vue&type=script&lang=js"

import "./UserManagement.vue?vue&type=style&index=0&id=55739d39&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55739d39"]])

export default __exports__